import { Modal } from "components/Modal";
import { Button, ButtonGroup, H3, Input } from "@adfenix/alexandria";
import { renameCustomTrigger } from "api/services/programService";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import Divider from "components/Divider";
import { availableTriggersQueryKey } from ".";
import { useState } from "react";
import { ProgramService } from "@adfenix/types";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

interface Props {
  selectedTrigger: ProgramService.CustomTriggerModel;
  resetSelectedTrigger: () => void;
  hqId: string;
}
export const RenameTriggerModal = ({
  selectedTrigger,
  resetSelectedTrigger,
  hqId
}: Props) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [triggerName, setTriggerName] = useState(selectedTrigger.name);

  const { isLoading, mutate } = useMutation(renameCustomTrigger, {
    onSuccess: () => {
      queryClient.invalidateQueries([availableTriggersQueryKey]);
      resetSelectedTrigger();
    },
    onError: () => {
      toast.error(t("login.error.generic.title"));
    }
  });

  return (
    <Modal show={true} onClose={() => resetSelectedTrigger()}>
      <Modal.Card style={{ padding: "16px" }}>
        <H3>Rename trigger</H3>
        <Divider margin="24px 0" />
        <Input
          label="Name"
          id="trigger-name"
          value={triggerName}
          onChange={e => setTriggerName(e.target.value)}
        />
        <Divider margin="24px 0" />
        <ButtonGroup justifyContent="end">
          <Button
            logLabel="cancel-trigger-edit-button"
            variant="secondary"
            disabled={isLoading}
            onClick={() => {
              resetSelectedTrigger();
            }}
          >
            Cancel
          </Button>
          <Button
            logLabel="delete-trigger-button"
            onClick={() =>
              mutate({
                hqId,
                triggerId: selectedTrigger.triggerId,
                newName: triggerName
              })
            }
            isLoading={isLoading}
            data-testid="delete-trigger"
          >
            Update
          </Button>
        </ButtonGroup>
      </Modal.Card>
    </Modal>
  );
};
